import React from "react";

export default function BreadCrumbs() {
  const pathSegments = window.location.pathname.split("/");
  const isLocationIncluded = pathSegments.includes("locations");
  const lastIndex = pathSegments.length - (isLocationIncluded ? 1 : 2);
  return (
    <div data-cy="BREAD-CRUMBS" className="display-flex">
      {pathSegments.slice(0, isLocationIncluded ? 3 : 2).map((data, index) => (
        <div
          key={index}
          className="display-flex flex-justify-content-center flex-align-items-center"
        >
          <div
            style={
              index === (isLocationIncluded ? 2 : 1) ? { fontSize: "20px" } : {}
            }
            className="font-color-tertiaryColor"
          >
            {getValidName(data)}
          </div>
          {index !== 0 &&
            index < (isLocationIncluded ? 2 : 1) &&
            lastIndex !== index && (
              <div className="padding-left-large padding-right-large font-color-tertiaryColor">
                /
              </div>
            )}
        </div>
      ))}
    </div>
  );
}

const getValidName = (name) => {
  switch (name) {
    case "filedView":
      return "Field View";
    case "locations":
      return "Locations";
    case "overview":
      return "Overview";
    case "complaints":
      return "Complaints";
    case "calls":
      return "Calls";
    case "devices":
      return "Devices";
    case "procedures":
      return "Procedures";
    case "reports":
      return "Reports";
    case "procedureHistory":
      return "Procedure History";
    case "workforce":
      return "Workforce";
    case "createWorkforce":
      return "Create Workforce";
    case "createProcedure":
      return "Create Procedure";
    case "liveFeed":
      return "Live Feeds";
    case "support":
      return "Support";
    default:
      return name;
  }
};
